import { render } from "./PgPage.vue?vue&type=template&id=8b70d792"
import script from "./PgPage.vue?vue&type=script&lang=js"
export * from "./PgPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__